<div class="text">
    <mat-icon>photo</mat-icon>
    <span *ngIf="!onlyIcon">{{photo}}</span>
</div>
<div class="overlay mat-elevation-z2" #overlay>
    <img [src]="photoUrl" alt="previsualización de imagen">
</div>
